import { Navigate, useOutlet } from "react-router-dom";

// TODO: maybe improve this to use most recently selected view?
export const INBOX_DRAFTS_SENT_DEFAULT_VIEW = "drafts";

export const InboxDraftsAndSentRedirectPage = () => {
  const outlet = useOutlet();

  if (outlet) return outlet;

  return <Navigate to={`./${INBOX_DRAFTS_SENT_DEFAULT_VIEW}`} />;
};
